import { Flex, Spinner, Text } from "@chakra-ui/react";

const PageLoader = ({ title }: { title: string }) => {
  return (
    <Flex
      h="100%"
      w="100%"
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
    >
      <Spinner color="brand" size={"xl"} />
      <Text>Loading the {title}...</Text>
    </Flex>
  );
};

export default PageLoader;
